(ns dashboard.components.file-preview
  (:require ["react" :as react]
            [dashboard.entity.document.viewer :as viewer]
            [dashboard.entity.organization.db :as org.db]
            [dashboard.ui :as ui]
            [re-frame.core :as rf]
            [reagent.core :as r]))

;; ----------------------------------------------------------------------------

(defn file-preview [{{:keys [url filename download-url document-id on-prevent-close]} :ctx}]
  (let [[loading set-loading] (react/useState true)
        org-members @(org.db/organization-members*)
        save-person (fn [person callback prevent-navigate-on-save]
                      (org.db/save-person
                       person
                       callback
                       prevent-navigate-on-save))]
    (if (.endsWith filename ".pdf")
      [:f> viewer/pdf-preview filename url org-members document-id save-person on-prevent-close]
      (let [gdocs-url  (str "https://docs.google.com/gview?url="
                            (js/encodeURIComponent url)
                            "&embedded=true")]
        [:div.card.is-flex.is-flex-direction-column
         {:style {:width "100%" :height "100%" :maxheight "100%"}}
         [:div.card-header.has-background-secondary.is-shadowless
          [:title.card-header-title filename]
          [:a.button.card-header-icon.is-align-self-center.is-secondary
           {:title "Download" :href download-url}
           [:span.icon [:i.fas.fa-download]]]
          [:button.card-header-icon {:on-click #(rf/dispatch [::ui/pop-modal])}
           [:span.icon [:i.fas.fa-xmark]]]]
         [:div.card-content.p-0.is-flex.is-flex-grow-1.is-justify-content-center
          {:style {:width "100%"
                   :min-height "88vh"}}
          (when loading
            [:progress.progress.is-small.is-info.mx-4.my-4
             {:style {:position "absolute" :width "100%"} :max "100"}])
          [:iframe {:style {:width "100%" :height "100%"}
                    :class (when loading "is-invisible")
                    :src gdocs-url
                    :on-load #(set-loading false)}]]]))))

(rf/reg-event-fx
 ::show-file-preview
 (fn [_ [_ download-url filename id {:keys [url]}]]
   (let [can-close (r/atom true)
         on-prevent-close (fn [value]
                            (reset! can-close value))
         on-close (fn [] (when @can-close (rf/dispatch [::ui/pop-modal])))]
     {:dispatch [::ui/push-modal
                 {:ctx {:url url
                        :filename filename
                        :document-id id
                        :download-url download-url
                        :on-prevent-close on-prevent-close}
                  :component file-preview
                  :keybinding-overrides {"Escape" on-close}
                  :content-props {:style {:width "98vw"
                                          :padding 0}
                                  :class [:document-viewer--modal]}}]})))
